import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { FileDown, Search, CheckCircle, Clock } from 'lucide-react';

const S = {
  heading: { fontSize:22, fontWeight:700, color:'#f6c90e', marginBottom:4 },
  sub: { fontSize:13, color:'#475569', marginBottom:24 },
  toolbar: { display:'flex', gap:12, marginBottom:16, flexWrap:'wrap' },
  searchBox: { display:'flex', alignItems:'center', gap:8, background:'#0e1420', border:'1px solid #1a2035', borderRadius:8, padding:'8px 12px', flex:1, maxWidth:300 },
  searchInput: { background:'none', border:'none', color:'#e2e8f0', fontSize:13, outline:'none', flex:1 },
  th: { padding:'10px 14px', textAlign:'left', fontSize:11, color:'#475569', textTransform:'uppercase', letterSpacing:1, borderBottom:'1px solid #1a2035' },
  td: { padding:'12px 14px', fontSize:13, color:'#cbd5e1', borderBottom:'1px solid #0f1117' },
  btn: (c='#f6c90e', disabled=false) => ({
    display:'flex', alignItems:'center', gap:5, padding:'6px 12px', borderRadius:7,
    background: disabled ? '#1a2035' : `${c}22`,
    color: disabled ? '#475569' : c,
    fontSize:12, fontWeight:600,
    cursor: disabled ? 'not-allowed' : 'pointer',
    border:`1px solid ${disabled ? '#2d3748' : c+'44'}`,
    whiteSpace:'nowrap',
  }),
};

const linkStyle = { background:'none', border:'none', color:'#e2e8f0', fontWeight:700, cursor:'pointer', padding:0, fontSize:'inherit', textDecoration:'underline', textDecorationColor:'rgba(226,232,240,0.3)', textUnderlineOffset:2 };

export default function DocumentoCemig() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState('');
  const [gerandoId, setGerandoId] = useState(null);
  const [view, setView] = useState('disponivel');
  const [erro, setErro] = useState('');

  const fetchLeads = (v) => {
    setErro('');
    api.get(`/documentos/leads-cemig/?view=${v || 'disponivel'}`).then(r => setLeads(r.data)).catch(() => setErro('Erro ao carregar dados. Tente atualizar a página.'));
  };
  useEffect(() => { fetchLeads('disponivel'); }, []);

  const switchView = (v) => { setView(v); setSearch(''); fetchLeads(v); };

  const filtered = leads.filter(l =>
    l.cliente?.toLowerCase().includes(search.toLowerCase()) ||
    l.cidade?.toLowerCase().includes(search.toLowerCase())
  );

  const gerar = async (leadId) => {
    setGerandoId(leadId);
    try {
      const resp = await api.post(`/documentos/gerar-cemig-lead/${leadId}/`, {}, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url; a.download = `cemig_${leadId}.pdf`; a.click();
      window.URL.revokeObjectURL(url);
      fetchLeads(view);
    } catch (e) {
      alert('Erro ao gerar Procuração: ' + (e.message || 'tente novamente'));
    } finally {
      setGerandoId(null);
    }
  };

  return (
    <div>
      <div style={S.heading}>Procuração</div>
      <div style={S.sub}>Geração de procurações para homologação dos clientes</div>
      {erro && (
        <div style={{ background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', borderRadius:8, padding:'10px 14px', color:'#f87171', fontSize:13, marginBottom:14 }}>{erro}</div>
      )}
      <div style={S.toolbar}>
        <div style={S.searchBox}>
          <Search size={14} color="#475569" />
          <input
            style={S.searchInput}
            placeholder="Buscar cliente..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div style={{ display:'flex', gap:6 }}>
          {[
            { v:'disponivel', l:'Disponível' },
            { v:'fechadas',   l:'Vendas Fechadas' },
          ].map(opt => (
            <button
              key={opt.v}
              onClick={() => switchView(opt.v)}
              style={{
                padding:'8px 16px', borderRadius:8, fontSize:13, fontWeight:600,
                cursor:'pointer', border:'1px solid',
                background: view === opt.v ? 'rgba(246,201,14,0.15)' : 'transparent',
                color:       view === opt.v ? '#f6c90e' : '#64748b',
                borderColor: view === opt.v ? 'rgba(246,201,14,0.4)' : '#1a2035',
              }}
            >{opt.l}</button>
          ))}
        </div>
      </div>

      <div style={{ background:'#0e1420', border:'1px solid #1a2035', borderRadius:12, overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr>
              <th style={S.th}>#</th>
              <th style={S.th}>Cliente</th>
              <th style={S.th}>Cidade</th>
              <th style={S.th}>Vendedor</th>
              <th style={S.th}>Valor da Venda</th>
              <th style={S.th}>{view === 'fechadas' ? 'Data da Venda' : 'Procuração'}</th>
              <th style={S.th}>Ação</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(l => {
              const loading = gerandoId === l.lead_id;
              return (
                <tr
                  key={l.lead_id}
                  onMouseEnter={e => e.currentTarget.style.background = '#111827'}
                  onMouseLeave={e => e.currentTarget.style.background = ''}
                >
                  <td style={S.td}>#{l.lead_id}</td>
                  <td style={S.td}><button style={linkStyle} onClick={() => navigate(`/jornada/${l.cliente_id}`)}>{l.cliente}</button></td>
                  <td style={S.td}>{l.cidade}</td>
                  <td style={S.td}>{l.vendedor}</td>
                  <td style={S.td}>
                    {l.valor_total_venda != null
                      ? <span style={{ color:'#f6c90e', fontWeight:600 }}>
                          R$ {Number(l.valor_total_venda).toLocaleString('pt-BR', { minimumFractionDigits:2 })}
                        </span>
                      : <span style={{ color:'#475569' }}>—</span>
                    }
                  </td>
                  <td style={S.td}>
                    {view === 'fechadas' ? (
                      <span style={{ color:'#4ade80', fontWeight:600, fontSize:13 }}>{l.venda_fechada_em || '—'}</span>
                    ) : l.cemig_gerado ? (
                      <span style={{ display:'flex', alignItems:'center', gap:5, color:'#4ade80', fontSize:12 }}>
                        <CheckCircle size={13} /> Gerado
                      </span>
                    ) : (
                      <span style={{ display:'flex', alignItems:'center', gap:5, color:'#475569', fontSize:12 }}>
                        <Clock size={13} /> Pendente
                      </span>
                    )}
                  </td>
                  <td style={S.td}>
                    <button
                      style={S.btn('#f6c90e', loading)}
                      onClick={() => !loading && gerar(l.lead_id)}
                      disabled={loading}
                    >
                      <FileDown size={13} />
                      {loading ? 'Gerando...' : l.cemig_gerado ? 'Regerar Procuração' : 'Gerar Procuração'}
                    </button>
                  </td>
                </tr>
              );
            })}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={7} style={{ ...S.td, textAlign:'center', color:'#475569', padding:32 }}>
                  Nenhum lead encontrado
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
